import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { useChatApiClient } from '../containers/Chat/useApiClient';

/**
 * Fetches the pageId linked to a project's dashboard tab.
 * Returns `{ pageId: number | null }`.
 */
export function useProjectDashboardPage(projectId: number | null): UseQueryResult<{ pageId: number | null }> {
  const apiClient = useChatApiClient();

  return useQuery({
    queryKey: ['projectDashboardPage', projectId],
    queryFn: async () => {
      if (projectId === null) {
        throw new Error('projectId is required to fetch project dashboard page');
      }

      return apiClient.pages.getProjectDashboardPage(projectId);
    },
    enabled: projectId !== null,
  });
}
